import QCXSelectTransportadorInternacionalAutocomplete from "../../../shared-components/select-transportador-internacional/QCXSelectTransportadorInternacionalAutocomplete";
import { isHAWB, isHBL } from "../../../features/house/houseUtils";

export default function QCXAgenteCargaOrAmadorComponent({
  id,
  name,
  label,
  disabled,
  type,
  initialValues,
  agenteTransportador = false,
  ...restProps
}) {
  if (isHAWB(type) || isHBL(type)) {
    return (
      <QCXSelectTransportadorInternacionalAutocomplete
        id={id}
        name={name}                      
        label={label}
        disabled={disabled}
        initialValues={initialValues}    
        agenteTransportador={agenteTransportador} 
        {...restProps}
      />
    );
  }

  return null;
}
